var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 2.5V10C6.66634 10.8841 7.01753 11.7319 7.64265 12.357C8.26777 12.9821 9.11562 13.3333 9.99967 13.3333C10.8837 13.3333 11.7316 12.9821 12.3567 12.357C12.9818 11.7319 13.333 10.8841 13.333 10V2.5H14.9997V10C14.9997 11.3261 14.4729 12.5979 13.5352 13.5355C12.5975 14.4732 11.3258 15 9.99967 15C8.67359 15 7.40182 14.4732 6.46414 13.5355C5.52646 12.5979 4.99967 11.3261 4.99967 10V2.5H6.66634ZM3.33301 16.6667H16.6663V18.3333H3.33301V16.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineIcon);
export default __webpack_public_path__ + "static/media/UnderlineIcon.76c03b8f4e5aa51c64e469174c86ee9c.svg";
export { ForwardRef as ReactComponent };